import { useContext, useEffect, useState } from "react";
import LandLordContext from "../../context/landlord/LandLordContext";
import { useNavigate, useParams } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import { haveValue, toast } from "../../helper/common";
import constants from "../../Utils/constants";
import {
  Badge,
  Button,
  Card,
  Icon,
  InfoList,
  Modal,
  Notice,
  PageHeader,
  SkeletonList,
} from "../../components/design";
import "../../components/Profiles/ProfileTable.css";
import "./PaymentDetails.css";
const PaymentDetails = () => {
  const { _t } = useTranslator();
  const landLordContext = useContext(LandLordContext);
  const { workspaceId } = useParams();
  const { fetchAssignedDetails, loadRentLeger, endLease } = landLordContext;
  const [loading, setLoading] = useState(true);
  const [ending, setEnding] = useState(false);
  const { assingedPropId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [upcomingDate, setUpcomingDate] = useState(new Date());
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [dueAmount, setDueAmount] = useState(0);
  const [depositHistory, setDepositHistory] = useState(null);
  const [confirmPopup, setConfirmPopup] = useState(false);

  useEffect(() => {
    if (!haveValue(assingedPropId)) {
      setLoading(false);
      return;
    }
    fetchAssignedDetails(assingedPropId)
      .then((res) => {
        setData(res.result);
        setLoading(false);
        var temp_data = new Date();
        var lease_start = new Date(res.result.payment_start);
        if (temp_data < lease_start) {
          temp_data = lease_start;
        }
        var check = new Date(
          temp_data.getFullYear(),
          temp_data.getMonth(),
          res.result?.payment_date
        );
        if (check < temp_data) {
          check = new Date(
            new Date(temp_data).getFullYear() +
              (new Date(temp_data).getMonth() === 11 ? 1 : 0),
            (new Date(temp_data).getMonth() + 1) % 12,
            res.result?.payment_date
          );
        }
        setUpcomingDate(check);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        toast.error(_t("errorWhileFetchingDetails"));
      });
  }, []);

  useEffect(() => {
    if (haveValue(assingedPropId)) {
      loadRentLeger(assingedPropId)
        .then((res) => {
          const data1 = res.result;

          var temp = 0;
          let temp_data = data1;
          if (data.status == constants.AWARDED) {
            data1.map((val) => {
              if (
                val?.status == constants.PENDING &&
                val?.type != constants.RENT
              ) {
                temp += +val?.amount;
              }

              if (val?.type == constants.DEPOSIT) {
                setDepositHistory(val);
              }
            });
            temp_data = data1.filter(
              (val) => val.status == constants.COMPLETED
            );
          } else {
            data1.map((val) => {
              if (val?.status == constants.PENDING) {
                temp += +val?.amount;
              }

              if (val?.type == constants.DEPOSIT) {
                setDepositHistory(val);
              }
            });
          }
          setDueAmount(temp);
          setPaymentHistory(temp_data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [data]);

  const handleEditDetails = () => {
    navigate(
      `/${workspaceId}/assignProperty/${data?.property_id?._id}?step=1&sharedProfile=${data?.shared_profile_id?._id}&editId=${data?._id}`
    );
  };
  const handleEndLease = (assignPropId) => {
    setEnding(true);
    endLease(assignPropId)
      .then((res) => {
        toast.success(_t("leaseEnded"));
        navigate(`/${workspaceId}/payment/property/list`);
      })
      .catch((err) => {
        toast.error(_t("errorWhileEndingLease"));
        console.log(err);
      })
      .finally(() => setEnding(false));
  };

  const listPath = `/${workspaceId}/payment/property/list`;
  const date = (value) => new Date(value).toLocaleDateString("en-GB");
  const tenantName = `${data?.tenant_id?.fname ?? ""} ${
    data?.tenant_id?.lname ?? ""
  }`.trim();
  const landlordName = `${data?.landlord_id?.fname_companyName ?? ""} ${
    data?.landlord_id?.lname ?? ""
  }`.trim();
  const streetNumber = parseInt(data?.property_id?.street_number, 10);
  const address = `${data?.property_id?.street} - ${
    Number.isNaN(streetNumber) ? "N/A" : String(streetNumber)
  }, ${data?.property_id?.floor_number}-${data?.property_id?.flat_number}`;
  const statusBadge =
    data?.status == constants.TENANT_PENDING ? (
      <Badge tone="warning">{_t("waitingForTenant")}</Badge>
    ) : data?.status == constants.AWARDED ? (
      <Badge>{_t("inPayment")}</Badge>
    ) : null;
  const ledgerTone = (status) =>
    status == constants.COMPLETED
      ? "lime"
      : status == constants.PENDING
        ? "warning"
        : "neutral";

  if (loading) {
    return (
      <div className="main-page-wrapper mb-4 payment-detail">
        <PageHeader
          title={_t("payments")}
          onBack={() => navigate(listPath)}
          backLabel={_t("back")}
        />
        <div className="payment-detail__grid">
          <SkeletonList rows={3} variant="card" label={_t("loading")} />
          <SkeletonList rows={2} variant="card" />
        </div>
      </div>
    );
  }

  if (!haveValue(data)) {
    return (
      <div className="main-page-wrapper mb-4 payment-detail">
        <PageHeader
          title={_t("payments")}
          onBack={() => navigate(listPath)}
          backLabel={_t("back")}
        />
        <p className="payment-detail__empty">{_t("noDetails")}</p>
      </div>
    );
  }

  return (
    <div className="main-page-wrapper mb-4 payment-detail">
      <PageHeader
        title={tenantName || _t("payments")}
        description={address}
        onBack={() => navigate(listPath)}
        backLabel={_t("back")}
      />

      {data?.status == constants.TENANT_PENDING && (
        <Notice className="payment-detail__notice">
          {_t("waitingForTenantToSetUpPayment")}
        </Notice>
      )}

      <div className="payment-detail__grid">
        <div className="payment-detail__main">
          <Card title={_t("upcoming")}>
            <table className="profile-table profile-table--compact">
              <thead>
                <tr>
                  <th>{_t("date")}</th>
                  <th>{_t("subject")}</th>
                  <th>{_t("amount")}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{date(upcomingDate)}</td>
                  <td>{_t("rent")}</td>
                  <td>
                    {data?.deposit_type == constants.SKOR_DEPOSIT
                      ? +data?.rent_amount + +data?.monthly_sub_amount
                      : data?.rent_amount}{" "}
                    €
                  </td>
                </tr>
              </tbody>
            </table>
          </Card>

          <Card title={_t("history")}>
            <table className="profile-table profile-table--compact">
              <thead>
                <tr>
                  <th>{_t("date")}</th>
                  <th>{_t("subject")}</th>
                  <th>{_t("amount")}</th>
                  <th>{_t("status")}</th>
                </tr>
              </thead>
              <tbody>
                {paymentHistory?.length > 0 ? (
                  paymentHistory.map((val) => (
                    <tr key={val?._id}>
                      <td>{date(val?.processing_date)}</td>
                      <td>{_t(val?.type)}</td>
                      <td>{val?.amount} €</td>
                      <td>
                        {val?.type == constants.DEPOSIT &&
                        haveValue(data?.deposit_slip) ? (
                          <Badge>{_t("proofUploaded")}</Badge>
                        ) : (
                          <Badge tone={ledgerTone(val?.status)}>
                            {_t(val?.status)}
                          </Badge>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="payment-detail__none">
                      {_t("noDetailsFound")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </Card>

          <Card title={_t("fullDepositDetails")}>
            <table className="profile-table profile-table--compact">
              <thead>
                <tr>
                  <th>{_t("amount")}</th>
                  <th>{_t("paidOn")}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="payment-detail__strong">
                    {data?.deposit_type == constants.SKOR_DEPOSIT
                      ? data?.rent_amount
                      : data?.deposit_amount}{" "}
                    €
                  </td>
                  <td>
                    {date(
                      depositHistory
                        ? depositHistory?.processing_date
                        : new Date()
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
            {haveValue(data?.deposit_slip) && (
              <div className="payment-detail__document">
                <p className="payment-detail__label">{_t("document")}</p>
                <div className="payment-detail__document-preview">
                  <iframe
                    src={`${data?.deposit_slip}`}
                    scrolling="no"
                    title={_t("document")}
                  />
                  <p>{data?.deposit_slip.split("-").slice(1).join("-")}</p>
                </div>
              </div>
            )}
          </Card>
        </div>

        <div className="payment-detail__side">
          <Card className="payment-detail__balance">
            <p className="payment-detail__label">{_t("currentBalanceDue")}</p>
            <p className="payment-detail__amount">{dueAmount} €</p>
            {statusBadge}
          </Card>

          <Card title={_t("leaseInformation")}>
            <InfoList
              layout="stacked"
              items={[
                {
                  label: _t("moveInAddress"),
                  value: (
                    <span className="payment-detail__address">
                      {landlordName && (
                        <span>
                          <Icon name="user" size={16} /> {landlordName}
                        </span>
                      )}
                      <span>
                        <Icon name="home" size={16} /> {address}
                      </span>
                    </span>
                  ),
                },
                {
                  label: _t("leaseStartDate"),
                  value: date(data?.payment_start),
                },
                {
                  label: _t("leaseEndDate"),
                  value: haveValue(data?.lease_end)
                    ? date(data?.lease_end)
                    : _t("open"),
                },
                { label: _t("rent"), value: `${data?.rent_amount} €` },
                { label: _t("deposit"), value: `${data?.deposit_amount} €` },
              ]}
            />
            <div className="payment-detail__actions">
              {data?.status == constants.TENANT_PENDING && (
                <Button
                  variant="secondary"
                  iconStart={<Icon name="edit" size={16} />}
                  onClick={handleEditDetails}
                >
                  {_t("editDetails")}
                </Button>
              )}
              <Button variant="danger" onClick={() => setConfirmPopup(true)}>
                {_t("endRental")}
              </Button>
            </div>
          </Card>
        </div>
      </div>

      <Modal
        open={confirmPopup}
        onClose={() => setConfirmPopup(false)}
        size="sm"
        title={_t("endRental")}
        description={_t(
          "areYouSureYouWantToEndRentalPleaseNoteThatThisActionCannotBeUndone"
        )}
        actions={
          <>
            <Button
              variant="secondary"
              size="lg"
              disabled={ending}
              onClick={() => setConfirmPopup(false)}
            >
              {_t("no")}
            </Button>
            <Button
              variant="danger"
              size="lg"
              loading={ending}
              onClick={() => handleEndLease(data?._id)}
            >
              {_t("yes")}
            </Button>
          </>
        }
      />
    </div>
  );
};

export default PaymentDetails;
